import React, { useEffect, useState } from 'react'
import { getDevicesUnlicenced, getDevicesUnlicencedglobal } from './request/request'
import { useAppSelector } from '../../../../redux/hooks'
import { useAuth } from '../../auth'
import Swal from 'sweetalert2'
import axios from 'axios'
import styles from '../statusGral/cloudStatusTable.module.scss'  // <-- Same SCSS used for sort icons, etc.
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import ImportExportIcon from '@mui/icons-material/ImportExport'

const API_URL = process.env.REACT_APP_API_URL

function Unlicenced(props: any) {
    const { currentUser } = useAuth()
    const tenant = useAppSelector((state) => state.TenantSlice.id)
    const Id = useAppSelector((state) => state.SuscriptionSlice.id)
    const Type = useAppSelector((state) => state.CloudSlice.Type)
    const nameregion = useAppSelector((state) => state.RegionSlice.name)

    // Pagination
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)

    // Table records
    const [records, setRecords] = useState<any[]>([])

    // Sorting
    const [sortColumn, setSortColumn] = useState<string>('')
    const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('asc')

    // Searching
    const [searchTerm, setSearchTerm] = useState('')
    const [searchColumn, setSearchColumn] = useState('All')

    // Delete device confirm
    const [swalInput, setSwalInput] = useState('')

    // -----------------------------
    // 1) Data loading
    // -----------------------------
    useEffect(() => {
        if (currentUser?.ListPermiso?.includes('CTXR.List')) {
            if (tenant === 0 && Id && Type !== 'CloudGlobal') {
                getDevicesUnlicenced(Id, Type, nameregion).then((response) => {
                    setRecords(response.data)
                })
            } else if (tenant !== 0 && Id && Type !== 'CloudGlobal') {
                getDevicesUnlicencedglobal(Id, tenant, Type, nameregion).then((response) => {
                    setRecords(response.data)
                })
            } else if (tenant === 0 && Id && Type === 'CloudGlobal') {
                getDevicesUnlicenced(Id).then((response) => {
                    setRecords(response.data)
                })
            } else if (tenant !== 0 && Id && Type === 'CloudGlobal') {
                getDevicesUnlicencedglobal(Id, tenant).then((response) => {
                    setRecords(response.data)
                })
            }
        }
    }, [Id, nameregion, props.num, Type, currentUser, tenant])

    useEffect(() => {
        if (currentUser?.ListPermiso?.includes('CTXR.List')) {
            if (tenant === 0 && Id === -1) {
                getDevicesUnlicenced(-1).then((response) => {
                    setRecords(response.data)
                })
            } else if (tenant !== 0 && Id === -1) {
                getDevicesUnlicencedglobal(-1, tenant).then((response) => {
                    setRecords(response.data)
                })
            }
        }
    }, [Type, Id, props.num, currentUser, tenant])

    useEffect(() => {
        if (Type) {
            setRecords([])
        }
    }, [Type])

    // -----------------------------
    // 2) Sorting logic
    // -----------------------------
    const handleSort = (column: string) => {
        if (sortColumn === column) {
            setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc')
        } else {
            setSortColumn(column)
            setSortDirection('asc')
        }
    }

    const getSortIcon = (col: string) => {
        if (sortColumn === col) {
            return sortDirection === 'asc' ? (
                <KeyboardArrowUpIcon className={styles['sort-icon']} />
            ) : (
                <KeyboardArrowDownIcon className={styles['sort-icon']} />
            )
        } else {
            return <ImportExportIcon className={styles['sort-icon']} style={{ opacity: 0.7 }} />
        }
    }

    function getValueForSort(item: any, column: string): string {
        switch (column) {
            case 'name':
                return item.name?.toLowerCase() || ''
            case 'description':
                return item.description?.toLowerCase() || ''
            case 'id':
                return item.id?.toString()?.toLowerCase() || ''
            case 'deactivate':
                // if needed to sort by date, we'd parse date
                return item.deactivate?.toString()?.toLowerCase() || ''
            default:
                return ''
        }
    }

    function applySort(data: any[]) {
        if (!sortColumn) return data
        const sorted = [...data].sort((a, b) => {
            const valA = getValueForSort(a, sortColumn)
            const valB = getValueForSort(b, sortColumn)
            if (valA < valB) return sortDirection === 'asc' ? -1 : 1
            if (valA > valB) return sortDirection === 'asc' ? 1 : -1
            return 0
        })
        return sorted
    }

    // -----------------------------
    // 3) Searching / Filtering
    // -----------------------------
    function applySearch(data: any[]) {
        if (!searchTerm) return data
        const lowerTerm = searchTerm.toLowerCase()
        return data.filter((d) => {
            if (searchColumn === 'All') {
                return (
                    d.name?.toLowerCase().includes(lowerTerm) ||
                    d.description?.toLowerCase().includes(lowerTerm) ||
                    d.id?.toString()?.toLowerCase().includes(lowerTerm) ||
                    d.deactivate?.toString()?.toLowerCase().includes(lowerTerm)
                )
            } else {
                let val = ''
                switch (searchColumn) {
                    case 'name':
                        val = d.name?.toLowerCase() || ''
                        break
                    case 'description':
                        val = d.description?.toLowerCase() || ''
                        break
                    case 'id':
                        val = d.id?.toString()?.toLowerCase() || ''
                        break
                    case 'deactivate':
                        val = d.deactivate?.toString()?.toLowerCase() || ''
                        break
                    default:
                        val = ''
                }
                return val.includes(lowerTerm)
            }
        })
    }

    // -----------------------------
    // 4) Pagination + combine
    // -----------------------------
    const filteredData = applySearch(records)
    const sortedData = applySort(filteredData)

    const totalItems = sortedData.length
    const totalPages = Math.ceil(totalItems / itemsPerPage)
    const startIndex = (currentPage - 1) * itemsPerPage
    const endIndex = startIndex + itemsPerPage
    const currentRecords = sortedData.slice(startIndex, endIndex)

    const handleRecordsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setItemsPerPage(Number(e.target.value))
        setCurrentPage(1)
    }

    const handlePageChange = (page: number) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page)
        }
    }

    // -----------------------------
    // 5) Format date (if needed)
    // -----------------------------
    function formatDate(dateString: string): string {
        if (!dateString) return ''
        const date = new Date(dateString)
        const day = date.getUTCDate().toString().padStart(2, '0')
        const month = (date.getUTCMonth() + 1).toString().padStart(2, '0')
        const year = date.getUTCFullYear()
        return `${day}-${month}-${year}`
    }

    // -----------------------------
    // 6) Delete Device logic
    // -----------------------------
    function deletedevice(id: any) {
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Are you sure?',
            text: 'Once deleted, you will not be able to recover this Device!',
            inputLabel: 'Enter "confirm" to continue...',
            input: 'text',
            inputPlaceholder: 'confirm',
            inputValue: swalInput,
            showCancelButton: true,
            confirmButtonColor: '#00BCD1',
            cancelButtonColor: '#FF4089',
            confirmButtonText: 'Yes, delete it!',
            preConfirm: (value) => {
                if (!value.toLowerCase().includes('confirm')) {
                    Swal.showValidationMessage('Please write the word "confirm"  to continue.')
                } else {
                    setSwalInput(value)
                }
            },
        }).then((result) => {
            if (result.isConfirmed) {
                setSwalInput('')
                if (tenant === 0 && Type !== 'Global') {
                    axios.delete(`${API_URL}/v1/ctxr/${Id}/${id}`).then((res) => {
                        if (res.data.error) {
                            Swal.fire({
                                icon: 'error',
                                title: 'The device cannot be removed because it is activated.',
                            })
                        } else {
                            Swal.fire('Deleted!', 'Your Device has been deleted.', 'success')
                        }
                        getDevicesUnlicenced(Id).then((response) => {
                            setRecords(response.data)
                        })
                    })
                } else if (tenant !== 0 && Type !== 'Global') {
                    axios
                        .delete(`${API_URL}/v1/ctxr/${Id}/${id}?tenantId=${tenant}`)
                        .then((res) => {
                            if (res.data.error) {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'The device cannot be removed because it is activated.',
                                })
                            } else {
                                Swal.fire('Deleted!', 'Your Device has been deleted.', 'success')
                            }
                            getDevicesUnlicencedglobal(Id, tenant).then((response) => {
                                setRecords(response.data)
                            })
                        })
                }
                if (tenant === 0 && Type === 'Global') {
                    axios.delete(`${API_URL}/v1/ctxr/${-1}/${id}`).then((res) => {
                        if (res.data.error) {
                            Swal.fire({
                                icon: 'error',
                                title: 'The Device cannot be removed because it is activated.',
                            })
                        } else {
                            Swal.fire('Deleted!', 'Your Device has been deleted.', 'success')
                        }
                        getDevicesUnlicenced(-1).then((response) => {
                            setRecords(response.data)
                        })
                    })
                } else if (tenant !== 0 && Type === 'Global') {
                    axios
                        .delete(`${API_URL}/v1/ctxr/${-1}/${id}?tenantId=${tenant}`)
                        .then((res) => {
                            if (res.data.error === 'licencia esta activada') {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'The Device cannot be removed because it is activated.',
                                })
                            } else {
                                Swal.fire('Deleted!', 'Your Device has been deleted.', 'success')
                            }
                            getDevicesUnlicencedglobal(-1, tenant).then((response) => {
                                setRecords(response.data)
                            })
                        })
                }
            } else {
                Swal.fire({ title: 'Your Device is safe!', icon: 'success' })
            }
        })
    }

    return (
        <>
            <div className="card">
                <div className="card-body py-3">
                    <div className="tab-content">
                        <div className="tab-pane fade show active" id="kt_table_widget_5_tab_1">
                            {/* Search + Filter Row */}
                            {records.length > 0 && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: '10px',
                                    }}
                                >
                                    <div>
                                        <span className="text-marino f-parrafo fw-semibold">
                                            Total Records: {totalItems}
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', height: '40px' }}>
                                        <div
                                            className="input-group custom-search-group"
                                            style={{ display: 'flex', height: '40px' }}
                                        >
                                            <span
                                                className="input-group-text"
                                                style={{
                                                    justifyContent: 'center',
                                                    height: '40px',
                                                    lineHeight: '40px',
                                                    padding: '0 8px',
                                                }}
                                            >
                                                <i
                                                    className="bi-search"
                                                    style={{
                                                        fontSize: '1rem',
                                                        color: '#FF4089',
                                                        verticalAlign: 'middle',
                                                    }}
                                                ></i>
                                            </span>
                                            <select
                                                className="form-select"
                                                style={{
                                                    border: '1px solid var(--bs-gray-300)',
                                                    width: '135px',
                                                    height: '40px',
                                                    lineHeight: '40px',
                                                    padding: '0 8px',
                                                    fontSize: '0.875rem',
                                                }}
                                                value={searchColumn}
                                                onChange={(e) => {
                                                    setSearchColumn(e.target.value)
                                                    setCurrentPage(1)
                                                }}
                                            >
                                                <option value="All">All</option>
                                                <option value="name">Name</option>
                                                <option value="description">Description</option>
                                                <option value="id">ID</option>
                                                <option value="deactivate">Deactivate</option>
                                            </select>
                                            <input
                                                type="text"
                                                className="form-control"
                                                style={{
                                                    width: '150px',
                                                    height: '40px',
                                                    lineHeight: '40px',
                                                    padding: '0 8px',
                                                    fontSize: '0.875rem',
                                                }}
                                                placeholder={`Search by ${searchColumn === 'All' ? 'All' : searchColumn
                                                    }`}
                                                value={searchTerm}
                                                onChange={(e) => {
                                                    setSearchTerm(e.target.value)
                                                    setCurrentPage(1)
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Table container */}
                            <div className="table-responsive" style={{ minHeight: '40vh' }}>
                                {currentRecords.length === 0 ? (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            height: '100px',
                                        }}
                                    >
                                        <span
                                            style={{
                                                color: '#FF4089',
                                                fontWeight: 'bold',
                                                fontSize: '1.5rem',
                                            }}
                                        >
                                            No Data Available
                                        </span>
                                    </div>
                                ) : (
                                    <table
                                        className="w-full f-parrafo caption-bottom custom-table"
                                        id="table"
                                    >
                                        <thead>
                                            <tr className="text-azul">
                                                {/* Name with sort */}
                                                <th
                                                    className="table-cell"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleSort('name')}
                                                >
                                                    <div className={styles['header-content']}>
                                                        <span>Name</span>
                                                        <span className={styles['sortable-column']}>
                                                            {getSortIcon('name')}
                                                        </span>
                                                    </div>
                                                </th>
                                                {/* Description with sort */}
                                                <th
                                                    className="table-cell"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleSort('description')}
                                                >
                                                    <div className={styles['header-content']}>
                                                        <span>Description</span>
                                                        <span className={styles['sortable-column']}>
                                                            {getSortIcon('description')}
                                                        </span>
                                                    </div>
                                                </th>
                                                {/* ID with sort */}
                                                <th
                                                    className="table-cell w-300px"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleSort('id')}
                                                >
                                                    <div className={styles['header-content']}>
                                                        <span>ID</span>
                                                        <span className={styles['sortable-column']}>{getSortIcon('id')}</span>
                                                    </div>
                                                </th>
                                                {/* Deactivate with sort */}
                                                <th
                                                    className="table-cell"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => handleSort('deactivate')}
                                                >
                                                    <div className={styles['header-content']}>
                                                        <span>Deactivate</span>
                                                        <span className={styles['sortable-column']}>
                                                            {getSortIcon('deactivate')}
                                                        </span>
                                                    </div>
                                                </th>

                                                <th className="table-cell w-200px">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {currentRecords.map((d: any, i: any) => (
                                                <tr key={i} className="table-row">
                                                    <td className="table-cell">{d.name}</td>
                                                    <td className="table-cell">{d.description}</td>
                                                    <td className="table-cell">{d.id}</td>
                                                    <td className="table-cell">{formatDate(d.deactivate)}</td>
                                                    <td className="table-cell">
                                                        {currentUser?.ListPermiso?.includes('CTXR.Delete') && (
                                                            <button
                                                                className="dropdown-itemm btn btn-danger"
                                                                type="button"
                                                                onClick={(e) => deletedevice(d.id)}
                                                            >
                                                                Delete Device
                                                            </button>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {/* Pagination */}
                            {sortedData.length > 0 && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginTop: '10px',
                                    }}
                                >
                                    <div>
                                        {currentPage > 1 && (
                                            <button
                                                onClick={() => handlePageChange(currentPage - 1)}
                                                className="btn btn-secondary"
                                            >
                                                Previous
                                            </button>
                                        )}
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <span>
                                            Page {currentPage} of {totalPages}
                                        </span>
                                    </div>
                                    <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                        {currentPage < totalPages && (
                                            <button
                                                onClick={() => handlePageChange(currentPage + 1)}
                                                className="btn btn-secondary"
                                            >
                                                Next
                                            </button>
                                        )}
                                        <div className="select-container">
                                            <select
                                                className="custom-select aligned-select text-center"
                                                aria-label="Select items per page"
                                                value={itemsPerPage}
                                                onChange={handleRecordsPerPageChange}
                                                style={{ width: '90px' }}
                                            >
                                                <option value={5}>5 rows</option>
                                                <option value={10}>10 rows</option>
                                                <option value={20}>20 rows</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {/* end::Tap pane */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Unlicenced
